var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSellDeckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.95289,
    width: 24,
    height: 32,
    rx: 4,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26272 21.8343C0.793979 15.1155 7.73146 5.27175 15.7002 8.2405",
    stroke: "#2196F3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9052 9.74095L13.7627 3.70925",
    stroke: "#2196F3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.228 7.62094L12.6065 11.7093",
    stroke: "#2196F3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2373 12.0715C23.706 18.7903 16.7685 28.634 8.79982 25.6653",
    stroke: "#2196F3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59483 24.1648L10.7373 30.1965",
    stroke: "#2196F3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27202 26.2848L11.8935 22.1965",
    stroke: "#2196F3",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.95289,
    width: 24,
    height: 32,
    rx: 4,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2595 8.64989C18.1575 8.81989 18.0442 8.95022 17.9195 9.04089C17.8062 9.12022 17.6645 9.15989 17.4945 9.15989C17.3018 9.15989 17.0752 9.06356 16.8145 8.87089C16.5538 8.67822 16.2252 8.46856 15.8285 8.24189C15.4432 8.00389 14.9728 7.78856 14.4175 7.59589C13.8735 7.40322 13.2105 7.30689 12.4285 7.30689C11.6918 7.30689 11.0402 7.40889 10.4735 7.61289C9.91817 7.80556 9.44783 8.07189 9.0625 8.41189C8.6885 8.75189 8.40517 9.15422 8.2125 9.61889C8.01983 10.0722 7.9235 10.5652 7.9235 11.0979C7.9235 11.7779 8.08783 12.3446 8.4165 12.7979C8.7565 13.2399 9.1985 13.6196 9.7425 13.9369C10.2978 14.2542 10.9212 14.5319 11.6125 14.7699C12.3152 14.9966 13.0292 15.2346 13.7545 15.4839C14.4912 15.7332 15.2052 16.0166 15.8965 16.3339C16.5992 16.6399 17.2225 17.0309 17.7665 17.5069C18.3218 17.9829 18.7638 18.5666 19.0925 19.2579C19.4325 19.9492 19.6025 20.7992 19.6025 21.8079C19.6025 22.8732 19.4212 23.8762 19.0585 24.8169C18.6958 25.7462 18.1632 26.5566 17.4605 27.2479C16.7692 27.9392 15.9135 28.4832 14.8935 28.8799C13.8848 29.2766 12.7345 29.4749 11.4425 29.4749C9.85583 29.4749 8.4165 29.1916 7.1245 28.6249C5.8325 28.0469 4.7275 27.2706 3.8095 26.2959L4.7615 24.7319C4.85217 24.6072 4.95983 24.5052 5.0845 24.4259C5.2205 24.3352 5.36783 24.2899 5.5265 24.2899C5.67383 24.2899 5.83817 24.3522 6.0195 24.4769C6.21217 24.5902 6.4275 24.7376 6.6655 24.9189C6.9035 25.1002 7.1755 25.2986 7.4815 25.5139C7.7875 25.7292 8.13317 25.9276 8.5185 26.1089C8.91517 26.2902 9.36283 26.4432 9.8615 26.5679C10.3602 26.6812 10.9212 26.7379 11.5445 26.7379C12.3265 26.7379 13.0235 26.6302 13.6355 26.4149C14.2475 26.1996 14.7632 25.8992 15.1825 25.5139C15.6132 25.1172 15.9418 24.6469 16.1685 24.1029C16.3952 23.5589 16.5085 22.9526 16.5085 22.2839C16.5085 21.5472 16.3385 20.9466 15.9985 20.4819C15.6698 20.0059 15.2335 19.6092 14.6895 19.2919C14.1455 18.9746 13.5222 18.7082 12.8195 18.4929C12.1168 18.2662 11.4028 18.0396 10.6775 17.8129C9.95217 17.5749 9.23817 17.3029 8.5355 16.9969C7.83283 16.6909 7.2095 16.2942 6.6655 15.8069C6.1215 15.3196 5.6795 14.7132 5.3395 13.9879C5.01083 13.2512 4.8465 12.3446 4.8465 11.2679C4.8465 10.4066 5.01083 9.57356 5.3395 8.76889C5.6795 7.96422 6.16683 7.25022 6.8015 6.62689C7.4475 6.00356 8.23517 5.50489 9.1645 5.13089C10.1052 4.75689 11.1818 4.56989 12.3945 4.56989C13.7545 4.56989 14.9898 4.78522 16.1005 5.21589C17.2225 5.64656 18.2085 6.26989 19.0585 7.08589L18.2595 8.64989Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.39039V31.5154",
    stroke: "#2196F3",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellDeckIcon);
export default __webpack_public_path__ + "static/media/sell-deck-icon.8170f1a237deabcddace45cd1c137623.svg";
export { ForwardRef as ReactComponent };